module.exports = __webpack_public_path__ + "media/images/magic_modules/homepage_grid_module/hgm_pattern-1-42a5cae8807ea57c85362d3f4ad89ded.png";